/* global femcare */

femcare.form.recaptcha = {
    language: $('body').data('google-language-code'),

    init: function () {
        window.renderExplicitRecaptcha = this.renderExplicitRecaptcha;
        var recaptchaSelector = '.g-recaptcha'; 

        if ($(recaptchaSelector).length) {
            var scriptSource = 'https://www.google.com/recaptcha/api.js?hl=' + this.language;
            this.appendScript(scriptSource);
        }
    },

    appendScript: function (source) {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.defer = true;
        script.src = source;
        $('head').append(script);
    },

    initDynamicRecaptcha: function () {
        var dynamicScriptSource = 'https://www.google.com/recaptcha/api.js?onload=renderExplicitRecaptcha&render=explicit&hl=' + this.language;
        var dynamicRecaptchaScriptAppended = $('script[src="' + dynamicScriptSource + '"]').length > 0;

        if (dynamicRecaptchaScriptAppended) {
            this.renderExplicitRecaptcha();
        } else {
            this.appendScript(dynamicScriptSource);
        }
    },

    renderExplicitRecaptcha: function () {
        var recaptchaId = 'dynamicRecaptcha';
        var $recaptcha = $('#' + recaptchaId);
        var siteKey = $recaptcha.data('sitekey');

        window.grecaptcha.render(recaptchaId, {
            sitekey: siteKey
        });
    }
};